class SeveneraPremiumPearls extends HTMLElement {
  #abort;
  #dialog;
  #openButton;
  #closeButton;
  #returnFocus;
  #previousOverflow = null;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    this.#dialog = this.querySelector('dialog');
    this.#openButton = this.querySelector('[data-sv-premium-open]');
    this.#closeButton = this.querySelector('[data-sv-premium-close]');
    if (!this.#dialog || !this.#openButton || !this.#closeButton) return;
    const options = { signal: this.#abort.signal };
    this.#openButton.addEventListener('click', () => this.open(), options);
    this.#closeButton.addEventListener('click', () => this.close(), options);
    this.#dialog.addEventListener('cancel', () => this.close(), options);
    this.#dialog.addEventListener('close', () => this.#restore(), options);
    this.#dialog.addEventListener('click', (event) => {
      if (event.target !== this.#dialog) return;
      const rect = this.#dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
    }, options);
  }

  disconnectedCallback() {
    this.#abort?.abort();
    if (this.#dialog?.open) this.#dialog.close();
    this.#restore();
  }

  open() {
    if (this.#dialog.open) return;
    this.#returnFocus = document.activeElement;
    this.#previousOverflow = document.documentElement.style.overflow;
    this.#dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    this.#openButton.setAttribute('aria-expanded', 'true');
    this.#closeButton.focus({ preventScroll: true });
  }

  close() {
    if (this.#dialog.open) this.#dialog.close();
  }

  #restore() {
    if (this.#previousOverflow !== null) {
      document.documentElement.style.overflow = this.#previousOverflow;
      this.#previousOverflow = null;
    }
    this.#openButton?.setAttribute('aria-expanded', 'false');
    if (this.#returnFocus?.isConnected) this.#returnFocus.focus({ preventScroll: true });
    this.#returnFocus = null;
  }
}
if (!customElements.get('sv-premium-pearls')) customElements.define('sv-premium-pearls', SeveneraPremiumPearls);
